module.exports = __webpack_public_path__ + "img/star-and-crescent.eb0a9e40.png";